@if (!subRouteActive()){
    <h1 class="text-3xl ps-4">
        {{ 'Käyttäjät' }}
    </h1>

    <div class="p-4 w-full flex flex-row justify-center gap-4">
        <input type="search" class="w-full text-center min-h-12 h-full bg-gray-100 max-w-2xl rounded-md overflow-hidden" [(ngModel)]="searchStr">
        <a [routerLink]="['./new']">
            <button class="bg-secondary text-white h-full p-3 flex gap-2 rounded-md" >
                <img src="assets/images/icons/new-user.svg" alt="" width="24" height="24"/>
                {{ "DASHBOARD.USER_LISTING.ADD_NEW_USER" | translate }}
            </button>
        </a>
    </div>

    <div class="w-full m-auto">
        <table class=" text-left capitalize max-w-screen-2xl w-full m-auto ">
            <thead class="bg-gray-50">
                <th scope="col" class="px-6 py-4">{{ "GLOBAL.EMAIL" | translate }}</th>
                <th scope="col" class="px-6 py-4">{{ "GLOBAL.PHONE_NUMBER" | translate }}</th>
                <th scope="col" class="px-6 py-4">{{ "GLOBAL.COMPANY.COMPANY" | translate }}</th>
                <th scope="col" class="px-6 py-4">{{ "GLOBAL.CREATED_AT" | translate }}</th>
                <th scope="col" class="px-6 py-4">{{ "GLOBAL.ROLES" | translate }}</th>
                <th scope="col" class="px-2 py-4">{{ "GLOBAL.ACTIONS" | translate }}</th>
            </thead>
            <tbody class="divide-y divide-gray-100 border-t border-gray-100">
                @if (!users()){
                    <tr>
                        <td colspan="6" class="px-6 py-4 text-center">
                            <app-loader-element/>
                        </td>
                    </tr>
                } @else {
                    @for (user of filteredUsers(); track user.id){
                        <tr class="hover:bg-gray-50 group">
                            <td class="px-6 py-4 align-middle lowercase"> {{ user.email }}</td>
                            <td class="px-6 py-4">{{ user.phoneNumber }}</td>
                            <td class="px-6 py-4">{{ user.company?.name }}</td>
                            <td class="px-6 py-4"> 1 </td>
                            <td class="px-6 py-4">
                                @for (role of user?.roles; track role) {
                                    <span> {{role}} @if(!$last){,} </span>
                                }
                            </td>
                            <th class="px-2 py-4 ">
                                <div class="flex items-center gap-12">
                                    <a [routerLink]="['./edit/', user.id]" [state]="{user:user}">
                                        <button class="animate-infinite w-fit flex items-center group/edit">
                                            {{ "GLOBAL.EDIT" | translate }}
                                            <img src="assets/images/icons/save.svg" class="group-hover/edit:animate-wiggle-more" alt="" width="28" height="28"/>
                                        </button>
                                    </a>
                                    <button class="animate-infinite w-fit flex items-center group/delete" (click)="onDeleteUSer(user)">
                                        {{ "GLOBAL.REMOVE" | translate }}
                                        <svg class="group-hover/delete:animate-wiggle-more" width="31" height="34" viewBox="0 0 31 34" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <rect width="31" height="34" fill="url(#pattern0_2016_9917)"/>
                                            <defs>
                                                <pattern id="pattern0_2016_9917" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                    <use xlink:href="#image0_2016_9917" transform="matrix(0.01 0 0 0.00875 0 0.0625)"/>
                                                </pattern>
                                                <image id="image0_2016_9917" width="100" height="100" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADaklEQVR4nO3dIYwVVxTG8dOGBEQNbUIxYIpoDa0AAwgQxVBEa4opmzDzfXff2yyEBEIC4mFYSMCAaRO2povoIsCAAQGYVrSmNSAAA6I1RQAJm2y4ZMIKEgwNc+ecM3N+yd9uMt/dEbvJu08khBBCCCGEEMJbABwmefl9an7G2z85/G8ATpLMbQTgTByBkcNgHIq9w2AfD4XkDpLHCnex1GG80cUOnmOH699c9qxmqzgQ6h9EHAj1x48Dof7gcSDUHzkOhPrDxoFQf0w3B8LX/oz4Lhuw+IGEEEIIIYQQghUA5of6xyKAebGG5OKA/0Xyq1hD8pz2MNTrrFgD4JCBYbJSB8Uakt8ZGCZrVNf1t2INgK3aw1CvLWJNVVWfGhgmazQ9Pb1ODPoAwAvtcdhxzTM3zy4WAXigPRC7775YRfL2AN+QW2IVgAXtgdh9v4hVJOcG+IacEqtIjrQHYvdNi1V1XX9jYKDccXvEqpTSlwYGyl1WVdVmsaqqqo+1B2LHjUajtWIZgKfaI7G7nol1AO4ZGCp31F2xjuRNA0PlLgJwQ6wj+fOADmRerBvYZxAnYl1KqRrQG3JArCO5W3sodlRK6WuxrqqqL7SHYnd9LtaNx+OPDAyVu6h5VvGA5BPtsVg4AP+JFyT/1h6M5ftLvABw3cBguXDXxAuSPxkYLJcMwI/iBYAT2oOxfMfFi5TS/gG8IT+IFyR3aQ/GwqWUdooXVVVt0h6M5ftMvJidnV1N8qWB0XKhXk5NTa0RTwD8a2C4XKh/xJuVj3vlPgbgD/GG5FXt4ViuK+INgAsGhsuFOi/ekDxqYLhcIgBHxBsA+7SHY7m+F29SStt7/IZsE29IbtQejoUajUYbxJvJZLKK5LL2eGy/5ebZxCMAjw0MmFvukXhF8ncDA+Y2A/CbeLXy7Ta5Zy2KVz29/+SseNXT+08Oild9vP+ktnivycDvP9kiXo3H4/UGBsxt1tzpIl5NJpMPSS5pj8j2WmqeSTwj+dDAkLmNmrtcxDsAd7SHZHvdFu9IXurRG7Ig3pE8rT0k22tOvAMwNjBkbqmReEdyr4Ehcxs1d7mId3Vdf6U9JFuquctFvJuZmflEe0i2VHOXi/RBcyeI9ph8/55LX/Tk/pO70hcrtztc9hy6+E7CEEIIIYQQQpDuvQKY6gJLRBYRuAAAAABJRU5ErkJggg=="/>
                                            </defs>
                                        </svg>
                                    </button>
                                </div>
                            </th>
                        </tr>
                    }
                }
            </tbody>
        </table>
    </div>
}
<router-outlet (activate)="onRouteChange(true)" (deactivate)="onRouteChange(false)"></router-outlet>
